// extracted by mini-css-extract-plugin
export default {"full":"style_full__d-Svi","icon":"style_icon__JIE49","iconImage":"style_iconImage__qabkN"};